export default function(store, { host }) {
  const Mute = store.defineModel('mute', {
    parseAttrs(attrs) {
      return attrs
    },

    relations: {
      belongsTo: {
        organization: { type: 'organization', foreignKey: 'organizationId' },
      },
    },
  })

  return Mute
}
